<template>
  <div class='map-box'>
    <div id='container'></div>
    <!--    <div id="panel"></div>-->
    <div class='search'>
      <el-date-picker
        v-model='date'
        size='mini'
        type='daterange'
        align='right'
        unlink-panels
        value-format='yyyy-MM-dd'
        range-separator='至'
        start-placeholder='开始日期'
        end-placeholder='结束日期'
        :picker-options='pickerOptions'>
      </el-date-picker>
      <el-button class='ml10' type='primary' size='mini' @click='search'>查询</el-button>
    </div>

  </div>
</template>

<script>
import { shipTracking } from '@/service/financial';

export default {
  data() {
    return {
      data:{lineLit:[],volIst:[{lng:'118.322071',lat:'31.303335',recvTime:'测试信息1'},{lng:'118.207383',lat:'31.294545',recvTime:'测试信息2'}]},
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
      date: [],
      map: '',
      lineArr: [],
      volIst:[],
      row: {},
      flag: false,
    };
  },
  methods: {
    async search() {
      if (this.date === null || this.date.length === 0) return this.$message.warning('请选择时间后查询轨迹');
      const [startDate, endDate] = this.date;
      const queryParams = {
        startDate,
        endDate,
        mmsi: this.row.mmsi,
      };
      const {
        status,
        message,
        data,
      } = await shipTracking(queryParams);
      if (status !== 0) return this.$message.warning(message);
      this.lineArr = data.lineLit;
      this.volIst=data.volIst;
      this.init();
    },
    init(row) {
      let that = this;
      row ? that.row = row : '';
      // MapLoader().then((AMap) => {
      this.map = new AMap.Map('container', {
        resizeEnable: true,
        center: ['106.550464', '29.563761'],
        zoom: 2, //地图显示的缩放级别
      });
      this.marker = new AMap.Marker({
        map: that.map,
        position: [Number(that.row.lng), Number(that.row.lat)],
        icon: require('../../../../assets/images/boat.png'),
        offset: new AMap.Pixel(-26, -36),
        autoRotation: true,
      });
      if (!row) {
        this.initroad();
        if(this.volIst.length>0){
          this.coordinateInformation(that);
        }
      }
    },
    //初始化轨迹
    initroad() {
      let that = this;

      // 绘制轨迹
      var polyline = new AMap.Polyline({
        map: that.map,
        path: that.lineArr,
        showDir: true,
        strokeColor: '#28F',  //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6,      //线宽
        // strokeStyle: "solid"  //线样式
      });
      that.map.setFitView();
    },
    coordinateInformation(that){
      let num=0;
      let number=0;
      if(this.volIst.length > 6000){
        number=4000;
      }else if(this.volIst.length > 4000){
        number=2000;
      }else if(this.volIst.length > 2000){
        number=1000;
      }else {
        number=400;
      }
      //标点信息
      this.volIst.forEach(value=>{
        if(num % number ===0 || (num+1)===this.volIst.length){
          that.marker2 = new AMap.Marker({
            map: that.map,
            position: [value.lng,value.lat],
            icon: require('../../../../assets/images/map-pin-2-fill.png'),
            bubble:true,
            offset: new AMap.Pixel(0, 0),
            title:value.recvTime,
            autoRotation: true,
          });
        }
        num++;
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.map-box {
  width: 100%;
  height: 100%;
  position: relative;

  #container {
    width: 100%;
    height: 100%;
  }

  #panel {
    display: none;
    position: fixed;
    background-color: white;
    max-height: 90%;
    overflow-y: auto;
    top: 10px;
    right: 10px;
    width: 280px;
  }

  #panel .amap-lib-driving {
    border-radius: 4px;
    overflow: hidden;
  }
}


.search {
  position: absolute;
  top: 10px;
  left: 10px;
}
</style>
